/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import TextareaAutosize from 'react-textarea-autosize';
import ReactMarkdown from 'react-markdown';
import { fetchPersonalNote, updatePersonalNote, deletePersonalNote } from '../../actions';

class CollectionItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,

    };
  }

  // component did update gets called everytime theres a change in props
  componentDidUpdate(prevProps, prevState) {
    // i added this if statement bc if we dont we're constatly calling fetch personal, so it only
    // gets called when we have diff note ids
    if (prevProps.personalNoteID !== this.props.personalNoteID) {
      // default is 0 or undefined
      if (this.props.personalNoteID !== '0' || this.props.personalNoteID === undefined) {
        this.props.fetchPersonalNote(this.props.personalNoteID);
        // this.setState({ title: this.props.personalNote?.Page.title, author: this.props?.personalNote?.Page.Author.username });
      }
    }
  }

  onTextInputChange = (event) => {
    this.setState({ text: event.target.value });
  }

  handleEditClick = (event) => {
    this.setState({ isEditing: true });
  }

  handleSaveClick = (event) => {
    this.props.updatePersonalNote(this.props.personalNote.id, { text: this.state.text });
    this.setState({ isEditing: false });
  }

  handleDeleteClick = () => {
    this.props.deletePersonalNote(this.props.personalNote.id);
  }

  renderNote() {
    if (this.state.isEditing) {
      return (
        <TextareaAutosize className="editingBox"
          onChange={this.onTextInputChange}
          placeholder="type your notes here"
          defaultValue={this.props.personalNote.text}
        />
      );
    } else {
      return (
        <div className="noteContent">
          <ReactMarkdown>{this.props.personalNote.text || ''}</ReactMarkdown>
        </div>
      );
    }
  }

  renderButtons = () => {
    if (this.state.isEditing) {
      return (
        <div className="note-buttons">
          <button type="button" onClick={this.handleSaveClick}>
            <i className="fas fa-check" />
          </button>
        </div>
      );
    } else {
      return (
        <div className="note-buttons">
          <button type="button" onClick={this.handleEditClick}>
            <i className="fas fa-edit" />
          </button>
        </div>
      );
    }
  }

  renderNoteContainer = () => {
    return (
      <div className="notes-container">
        <p id="notes-header">Personal notes about this story go here</p>
        <div className="note-details">
          {this.renderNote()}
          {this.renderButtons()}
        </div>
      </div>
    );
  }

  render() {
    const page = this.props?.personalNote?.Page;
    if (!page) {
      return (
        <>
          <p>Click on a story in your collection to view or write notes.</p>
        </>
      );
    }
    return (
      <div className="collection-item">
        <div className="collection-story-link">
          <NavLink className="collection-detail" to={`/books/${page?.Chapter?.Book?.id}/chapters/${page?.Chapter?.id}/pages/${page?.id}`}>
            <p>Story: {this.props.personalNote?.Page.title}</p>
            <p>Author: {page?.Author?.username}</p>
          </NavLink>
        </div>
        <button type="button" onClick={this.handleDeleteClick}>Remove from Collection</button>
        {this.renderNoteContainer()}
      </div>
    );
  }
}

// connects particular parts of redux state to this components props
const mapStateToProps = (state, ownProps) => (
  {
    personalNoteID: ownProps.personalNoteId,
    personalNote: state.personalNotes.current,
  }
);

// react-redux glue -- outputs Container that know state in props
// also with an optional HOC withRouter
// export default withRouter(connect(mapStateToProps, { fetchChapters, fetchBook })(TableOfContents));

// export default withRouter(Notebook);
export default withRouter(connect(mapStateToProps, { fetchPersonalNote, updatePersonalNote, deletePersonalNote })(CollectionItem));
